import intranetApi from "../api/intranet-api";

/**
 * NMU-478: staff-intranet portal cards.
 *
 * Bare-bean endpoints like Programs and Slider, so `status` is only read as an
 * envelope verdict when it is actually a string — on these beans it is the
 * published flag (see NMU-453).
 */
const assertSuccess = (resp) => {
    if (resp && typeof resp.status === "string" && resp.status !== "SUCCESS") {
        throw resp.responseMsgTh || resp.responseMsgEn || resp.message || resp.status;
    }
    return resp;
};

const normalizeList = (resp) => {
    if (!resp) return [];
    if (Array.isArray(resp)) return resp;
    const raw = resp.data || resp.list;
    return Array.isArray(raw) ? raw : [];
};

const normalizeBean = (resp) => {
    if (!resp) return null;
    if (resp.bean) return resp.bean;
    if (resp.data && !Array.isArray(resp.data)) return resp.data;
    return resp;
};

const searchBySection = async (section) => normalizeList(await intranetApi.searchBySection(section));

const getById = async (id) => {
    const resp = await intranetApi.getById(id);
    assertSuccess(resp);
    return normalizeBean(resp);
};

const add = async (bean) => assertSuccess(await intranetApi.add(bean));
const edit = async (id, bean) => assertSuccess(await intranetApi.edit(id, bean));
const remove = async (id) => assertSuccess(await intranetApi.remove(id));
const reorder = async (section, orderedIds) => assertSuccess(await intranetApi.reorder(section, orderedIds));

// NMU-601: Workspace & Shortcuts tabs. The list comes back in display order.
const listTabs = async () => normalizeList(await intranetApi.listTabs());
const addTab = async (bean) => assertSuccess(await intranetApi.addTab(bean));
const editTab = async (id, bean) => assertSuccess(await intranetApi.editTab(id, bean));
const removeTab = async (id) => assertSuccess(await intranetApi.removeTab(id));

const intranetService = { searchBySection, getById, add, edit, remove, reorder, listTabs, addTab, editTab, removeTab };

export default intranetService;
